import React, { useState } from "react";
import "../styles/CancelOrderPage.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";

import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import CancelOrderForm from "../components/CancelOrder/CancelOrderForm";
import CancelOrderItems from "../components/CancelOrder/CancelOrderItems";
import CancelConfirmModal from "../components/CancelOrder/CancelConfirmModal";
import { useCancelOrder } from "../hooks/useCancelOrder";

const CancelOrderPage = () => {
    const navigate = useNavigate();
    const { orderNo } = useParams();
    const location = useLocation();
    const items = location?.state?.items || [];
    const [showModal, setShowModal] = useState(false);
    const {
        reason,
        setReason,
        reasonList,
        comments,
        setComments,
        loading,
        submitCancel,
    } = useCancelOrder(orderNo, items, navigate);

    const breadcrumbPaths = [
        {
            label: "Orders",
            to: "/accounts/orders",
        },
        {
            label: "Cancel Order",
        },
    ];

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                transition={Slide}
            />

            <Breadcrumbs paths={breadcrumbPaths} />

            <div className="cancel-order-container">
                <CancelOrderForm
                    reason={reason}
                    setReason={setReason}
                    reasonList={reasonList}
                    comments={comments}
                    setComments={setComments}
                    loading={loading}
                    openModal={() => setShowModal(true)}
                />

                <CancelOrderItems items={items} />
            </div>

            <CancelConfirmModal
                show={showModal}
                close={() => setShowModal(false)}
                confirm={submitCancel}
                loading={loading}
            />

            <Footer />
        </>
    );
};

export default CancelOrderPage;